import React, { Component } from 'react';
import LessonRouter from './LessonRouter.js';
import axios from 'axios';


class App extends Component {
  componentWillMount(){
    const request = axios.get('/api/current_user');
    request.then((res) => {
      this.setState({user:res.data});
    }).catch(error => console.log(error));
  }

  render() {
    if(this.state === null)
      return null;

    return (
      <div id="App">
        <LessonRouter loggedIn={this.state.user}/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js